export default "__VITE_ASSET__BOUQVWVm__"